export const name = "OCTET_LENGTH";
export const summary = `Alias for \`BYTE_LENGTH\`.`;
export const reference = `
## OCTET_LENGTH

Alias for \`BYTE_LENGTH\`.

\`\`\`
OCTET_LENGTH(value)
\`\`\`

### Alias for BYTE_LENGTH.




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
